import { isOk } from "../../result";
import { Discount } from "../../models/Discount";
import {
  DiscountActionTypes,
  REQUEST_DISCOUNTS,
  REQUEST_DISCOUNTS_DONE
} from "./types";
import * as DiscountApi from "../../api/discountApi";
import { DiscountType } from "../../views/discounts/types";

function fetchDiscounts(
  discounts: ReadonlyArray<Discount>,
  discountTypes: ReadonlyArray<DiscountType>
): DiscountActionTypes {
  return {
    type: REQUEST_DISCOUNTS,
    payload: { discounts: discounts, discountTypes: discountTypes }
  };
}

function fetchDiscountsDone(
  discounts: ReadonlyArray<Discount>,
  discountTypes: ReadonlyArray<DiscountType>
): DiscountActionTypes {
  return {
    type: REQUEST_DISCOUNTS_DONE,
    payload: { discounts: discounts, discountTypes: discountTypes }
  };
}

export const thunkFetchDiscounts = () => async (dispatch: any) => {
  try {
    dispatch(fetchDiscounts([], []));
    const discountsRes = await DiscountApi.list();
    const typesRes = await DiscountApi.listTypes();

    if (isOk(discountsRes) && isOk(typesRes)) {
      let types = [...typesRes.value].sort((a, b) =>
        a.viewOrder > b.viewOrder ? 1 : -1
      );
      dispatch(fetchDiscountsDone(discountsRes.value, types));
    } else {
      throw Error("Error fetching discounts and discount types");
    }
  } catch (error) {
    console.log(error);
    dispatch(fetchDiscountsDone([], []));
  }
};
